import React from "react"
import progress from "../../assets/images/logo.svg"
import { useStateValue } from "../../context/StateProvider"

const Progress = () => {
    const [{ inProgress }] = useStateValue()

    return (
        inProgress ? 
        <div className="progress-container">
            <img className="progress-gif" src={progress} alt="loading..." />
            <div>connecting...</div>
        </div> : null
    )
}

export default Progress